var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCustomisableEqualiserIcon = function SvgCustomisableEqualiserIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M3.999 15.258c.552 0 1-.434 1-.97 0-.535-.448-.969-1-.969-.553 0-1 .434-1 .97 0 .535.447.97 1 .97m0 .97c1.104 0 2-.868 2-1.94 0-1.07-.896-1.939-2-1.939s-2 .869-2 1.94.895 1.94 2 1.94",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M4.499 3.137a.493.493 0 0 0-.5-.485c-.277 0-.5.217-.5.485v9.273a2.06 2.06 0 0 1 1 0zm0 13.03a2.06 2.06 0 0 1-1 0v5.394c0 .268.223.485.5.485.276 0 .5-.217.5-.485zM9.301 7.5c.553 0 1-.433 1-.969 0-.535-.447-.97-1-.97s-1 .435-1 .97c0 .536.448.97 1 .97m0 .97c1.105 0 2-.868 2-1.939s-.895-1.94-2-1.94-2 .869-2 1.94.896 1.94 2 1.94",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M9.801 3.137a.493.493 0 0 0-.5-.485c-.276 0-.5.217-.5.485v1.516a2.06 2.06 0 0 1 1 0zm0 5.272a2.06 2.06 0 0 1-1 0v13.152c0 .268.224.485.5.485s.5-.217.5-.485zM14.7 19.137c.552 0 1-.434 1-.97 0-.535-.448-.97-1-.97-.553 0-1 .435-1 .97 0 .536.447.97 1 .97m0 .97c1.104 0 2-.868 2-1.94 0-1.07-.896-1.939-2-1.939s-2 .868-2 1.94c0 1.07.895 1.939 2 1.939",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M15.2 3.137a.493.493 0 0 0-.5-.485c-.276 0-.5.217-.5.485V16.29a2.06 2.06 0 0 1 1 0zm0 16.909a2.06 2.06 0 0 1-1 0v1.515c0 .268.224.485.5.485s.5-.217.5-.485zM19.999 11.38c.552 0 1-.435 1-.97 0-.536-.448-.97-1-.97-.553 0-1 .434-1 .97 0 .535.447.97 1 .97m0 .97c1.104 0 2-.869 2-1.94s-.896-1.94-2-1.94-2 .869-2 1.94.895 1.94 2 1.94",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M20.499 3.137a.493.493 0 0 0-.5-.485c-.277 0-.5.217-.5.485v5.395a2.06 2.06 0 0 1 1 0zm0 9.151a2.06 2.06 0 0 1-1 0v9.273c0 .268.223.485.5.485.276 0 .5-.217.5-.485z",
    clipRule: "evenodd"
  })));
};
export default SvgCustomisableEqualiserIcon;